module.exports = __webpack_public_path__ + "img/donatella-araujo.ad105a7e.jpg";